import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

// src/API/Address/GetPamCodeSuggessionAsync.ts
export interface Address {
    digiPin: string;
    id: string;
    latitude: number;
    longitude: number;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressType: string;
    pinCode?: string;
    blockCode?: string;
    addressCode?: string;
    pamCode?: string;
    isFavourite?: boolean;
    createdDate?: string;
  }
/**
 *
 * @param latitude - The latitude coordinate.
 * @param longitude - The longitude coordinate.
 * @param token - The authentication token.
 * @returns A promise that resolves to the fetched data.
 */
export async function getPamCodeSuggessionAsync(
    latitude: number,
    longitude: number,
    token: string,
    t: (key: string) => string
  ): Promise<any> {
    if (!navigator.onLine) {
      toast.error(t("internetConnection"), { toastId: "offline-error" });      return null;
    }
  
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(
        `${baseUrl}/api/Address/GetPamCodeSuggessionAsync?latitude=${latitude}&longitude=${longitude}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      // console.error("Error in getPamCodeSuggessionAsync:", error);
      throw error;
    }
  }
  